import authInitializer from '../modules/auth/authInitializer'

export default [authInitializer]
